export const SET_ENTITLEMENTS = 'SET_ENTITLEMENTS'

export type Entitlements = Array<string>
